import { Injectable, Inject } from '@angular/core';
import { RequestCommon, Szoa304aRequest, Szoa304aRequestAceptInfo, Szoa304aResponse, SZOA304AService, Szoa308aResponseGasAceptSearchResultDtoAceptInfo } from 'sg-api';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { SgkbConstains } from '../../../../sg-kb-shared/sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkb941dSzoa304aService {

  constructor(private sZOA304AService: SZOA304AService, private apiCommonService: ApiCommonService, private timeApiService: TimeApiService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }
  /**
   * ガス契約情報変更受付登録（登録）
   *
   * @param {Szoa304aRequest} szoa304aRequest
   * @return {*}  {Observable<Szoa304aResponse>}
   * @memberof UsedSgkb941dSzoa304aService
   */
  registReception(szoa304aRequest: any): Observable<Szoa304aResponse> {

    let request: Szoa304aRequest = {
      aceptInfo: this.createReceptionInfo(szoa304aRequest.aceptInfo),
      ctrCommonInfo: szoa304aRequest.ctrCommonInfo,
      ftiGoodsInfo: szoa304aRequest.ftiGoodsInfo,
      gasConInfo: szoa304aRequest.gasConInfo,
      requestCommon: this.createCommonRequestCommon(szoa304aRequest.requestCommon.requestCustomize)
    }

    if (szoa304aRequest.gasConvalInfo != null) {
      request.gasConvalInfo = szoa304aRequest.gasConvalInfo;
    }

    if (szoa304aRequest.ctrTankaInfo != null) {
      request.ctrTankaInfo = szoa304aRequest.ctrTankaInfo;
    }

    // 更新区分 1:登録 を設定
    request.aceptInfo.updateDiv = SgkbConstains.CODE.UPDATE_DIV.REGIST;
    return this.sendPostRequest(this.apiCommonService.setRequestCommon(<Szoa304aRequest>request));
  }

  /**
   * ガス契約情報変更受付登録（変更）
   *
   * @param {*} szoa304aRequest
   * @return {*}  {Observable<Szoa304aResponse>}
   * @memberof UsedSgkb941dSzoa304aService
   */
  updateReception(szoa304aRequest: any): Observable<Szoa304aResponse> {

    let request: Szoa304aRequest = {
      aceptInfo: this.createReceptionInfo(szoa304aRequest.aceptInfo),
      ctrCommonInfo: szoa304aRequest.ctrCommonInfo,
      ftiGoodsInfo: szoa304aRequest.ftiGoodsInfo,
      gasConInfo: szoa304aRequest.gasConInfo,
      requestCommon: this.createCommonRequestCommon(szoa304aRequest.requestCommon.requestCustomize)
    }

    if (szoa304aRequest.gasConvalInfo != null) {
      request.gasConvalInfo = szoa304aRequest.gasConvalInfo;
    }

    if (szoa304aRequest.ctrTankaInfo != null) {
      request.ctrTankaInfo = szoa304aRequest.ctrTankaInfo;
    }

    // 更新区分 2:変更 を設定
    request.aceptInfo.updateDiv = SgkbConstains.CODE.UPDATE_DIV.CHANGE;
    return this.sendPostRequest(this.apiCommonService.setRequestCommon(<Szoa304aRequest>request));
  }

  /**
   * ガス契約情報変更受付登録（削除）
   *
   * @param {Szoa304aRequest} szoa304aRequest
   * @return {*}  {Observable<Szoa304aResponse>}
   * @memberof UsedSgkb941dSzoa304aService
   */
  deleteReception(szoa304aRequest: Szoa304aRequest): Observable<Szoa304aResponse> {
    let request: Szoa304aRequest = {
      aceptInfo: this.createReceptionInfo(szoa304aRequest.aceptInfo),
      requestCommon: this.createCommonRequestCommon(szoa304aRequest.requestCommon.requestCustomize)
    }
    // 更新区分 3:取消 を設定
    request.aceptInfo.updateDiv = SgkbConstains.CODE.UPDATE_DIV.CANCEL;
    // リクエスト情報を設定してリクエスト送信
    return this.sendPostRequest(this.apiCommonService.setRequestCommon(<Szoa304aRequest>request));
  }

  /**
   * 受付情報リクエスト作成（共通）
   *
   * @private
   * @param {Szoa308aResponseGasAceptSearchResultDtoAceptInfo} aceptInfo
   * @return {*}  {Szoa209aRequestAceptInfo}
   * @memberof UsedSgkb941dSzoa304aService
   */
  private createReceptionInfo(aceptInfo: Szoa308aResponseGasAceptSearchResultDtoAceptInfo): Szoa304aRequestAceptInfo {
    let szoa304aRequestAceptInfo: Szoa304aRequestAceptInfo = {
      aceptNo: aceptInfo?.aceptNo,
      aceptRrkno: aceptInfo?.aceptRrkno,
      updateSrno: aceptInfo?.updateSrno,
      updateDiv: '', // 各処理にて設定
      aceptClsfy: aceptInfo.aceptClsfy,
      visitNo: aceptInfo.visitNo,
      firstSrvctrNo: aceptInfo.firstSrvctrNo,
      logicDeviceNo: aceptInfo.logicDeviceNo,
      simltnAceptNo: aceptInfo?.simltnAceptNo,
      recptFixNo: aceptInfo?.recptFixNo,
      aceptDate: this.timeApiService.getNowDateString(),
      aceptHms: this.timeApiService.getNowTimeString(),
      // aceptSosikiCode: '9999',  //受付担当組織番号
      // aceptStaffNo: '99999',  //受付担当社員番号
      aceptSosikiCode: aceptInfo?.aceptSosikiCode,  //受付担当組織番号
      aceptStaffNo: aceptInfo?.aceptStaffNo,  //受付担当社員番号
      extCnnctNo: aceptInfo.extCnnctNo,
    };
    if (aceptInfo.aceptClsfy == '040201') {
      szoa304aRequestAceptInfo.cnscncYhiflg = aceptInfo.cnscncYhiflg;
    }
    return szoa304aRequestAceptInfo;
  }

  /**
   * SZOA401Aリクエスト送信
   *
   * @private
   * @param {Szoa304aRequest} request
   * @return {*}  {Observable<Szoa304aResponse>}
   * @memberof UsedSgkb941dSzoa304aService
   */
  private sendPostRequest(request: Szoa304aRequest): Observable<Szoa304aResponse> {

    // 年月日項目のフォーマット
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);

    return this.sZOA304AService.c11WSZOA304APost(request, 'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_SGKB, SgkbConstains.MESSAGE.APINAME_SZOA304A);
          return throwError(err.message);
        })
      );
  }

  /**
   * requestCustomizeを入れる
   */
  private createCommonRequestCommon(requestCustomize: object): RequestCommon {
    return <RequestCommon>{
      requestCustomize: requestCustomize,
    };
  }
}